import styled from 'styled-components'
import AlertMui from '@mui/material/Alert'
import SnackbarMui from '@mui/material/Snackbar'

const Snackbar = styled(SnackbarMui)`
  width: 100%;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    right: 0;
    left: 0;
  }
`

const Alert = styled(AlertMui)`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 700px;
  min-height: 56px;
  margin: 0 ${({ theme }) => theme.spacing()};
`

export { Snackbar, Alert }
